// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-document-fields',
    // #endregion
    // #region Properties
    props: {
        fields: {
            type: Array,
            required: false,
            default: []
        },
        rowClasses: {
            type: String,
            required: false,
            default: ''
        },
    },
    // #endregion
});
// #endregion
